<template>
  <transition
      name="showAnimat"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
  >
    <div class="background" v-if="isVisibilityModal" @click="modalAction">
      <div class="background"></div>
        <div class="modal_market">
          <h1 class="footer__market_open_p_in_window">{{button}}</h1>
          <div class="mobile__block_market">
            <div class="modal_market_cross" @click="modalAction">
              <i class="fas fa-times"></i>
            </div>
            <div>
              <a class="block_market_icon"
                 v-for="item in MarketItems"
                 :key="item.id"
                 :href="item.url"
              >
                <img
                    class="mobile__footer_market_icon"
                    :src='item.imageMob'
                    :alt="item.name"
                >
              </a>
            </div>
          </div>
        </div>
      </div>
  </transition>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "ModalWindowMarket",
  data: () => ({
    button: ''
  }),
  methods: {
    buttonUpdate() {
      this.button = this.marketplaces.btn_text
    },
    modalAction() {
      this.$store.dispatch('modalAction', false)
      document.body.classList.remove('fix')
    }
  },
  computed: {
    ...mapGetters(['marketplaces','MarketItems']),
    isVisibilityModal() {
      return this.$store.state.button.isVisibilityModal
    },
  },
  async mounted() {
    await this.$store.dispatch('fetchMarketplaces')
    await this.$store.dispatch('fetchLand')
    this.$nextTick(this.buttonUpdate)
  }
}
</script>